// extracted by mini-css-extract-plugin
export default {"floating_box":"floating_box__4240d1f3","transparent":"transparent__4240d1f3","hidden":"hidden__4240d1f3"};